<template>
  <div class="columns">
    <div class="column is-one-third">
      <div class="card is-flex is-flex-direction-column" style="height: 115px">
        <div class="px-1 has-text-weight-semibold has-text-centered has-background-primary has-text-white">
          Satelite
        </div>
        <div class="p-3 is-flex is-align-items-center is-flex-grow-1" :class="{ 
        'has-background-success-light': terminal?.networkStatus?.satelliteOnline == true, 
        'has-background-danger-light': terminal?.networkStatus?.satelliteOnline == false, 
        'has-background-grey-lighter': terminal?.networkStatus?.satelliteOnline === undefined }">
          <remote-satellite-signal :strength="terminal?.networkStatus?.satelliteSignal?.toString()" v-if="terminal?.networkStatus?.satelliteOnline" />
          <div class="has-text-centered is-flex-grow-1">
            <p class="is-size-3 mb-0">{{ terminal?.networkStatus?.satelliteSignal ? `${terminal?.networkStatus?.satelliteSignal}` : 'Unavailable' }}</p>
            <span v-if="terminal?.networkStatus?.satelliteSignal">db</span>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-one-third">
      <div class="card is-flex is-flex-direction-column" style="height: 115px">
        <div class="px-1 has-text-weight-semibold has-text-centered has-background-primary has-text-white">
          Cellular
        </div>
        <div class="p-3 is-flex is-align-items-center is-flex-grow-1" :class="{ 
        'has-background-success-light': terminal?.networkStatus?.cellularOnline == true, 
        'has-background-danger-light': terminal?.networkStatus?.cellularOnline == false, 
        'has-background-grey-lighter': terminal?.networkStatus?.cellularOnline === undefined }">
          <remote-cellular-signal :strength="terminal?.networkStatus?.cellularSignal" v-if="terminal?.networkStatus?.cellularOnline" />
          <div class="has-text-centered is-flex-grow-1">
            <p class="is-size-3 mb-0">{{ terminal?.networkStatus?.cellularSignal ? `${terminal?.networkStatus?.cellularSignal}` : `Unavailable` }}</p>
            <span v-if="terminal?.networkStatus?.cellularSignal">db</span>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-one-third">
      <div class="card is-flex is-flex-direction-column" style="height: 115px">
        <div class="px-1 has-text-weight-semibold has-text-centered has-background-primary has-text-white">
          Local WiFi
        </div>
        <div class="p-3 is-flex is-flex-grow-1 is-align-items-center is-justify-content-center" :class="{ 
        'has-background-success-light': terminal?.networkStatus?.wifi == true, 
        'has-background-danger-light': terminal?.networkStatus?.wifi == false, 
        'has-background-grey-lighter': terminal?.networkStatus?.wifi === undefined }">
          <div class="has-text-centered is-size-3 mb-0">{{ terminal?.networkStatus?.wifi ? 'Enabled' : 'Disabled' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useTerminalsStore } from '../terminals-store';

import RemoteSatelliteSignal from '../../remotes/components/RemoteDetailSatelliteSignal.vue';
import RemoteCellularSignal from '../../remotes/components/RemoteDetailCellularSignal.vue';

const store = useTerminalsStore();
const terminal = computed(() => store.state.terminal);
</script>
